<template>
  <div class="wg-row" :style="{ minHeight: (windowHeight - 350) + 'px' }">
    <nav class="wg-xs-12 wg-md-2 categories categories-menu no-select" :style="{top: (topOffset - 2) + 'px'}">
      <ul class="display-flex com-anm22-app-scrolling-panel" :style="menuStyle">
        <div class="display-flex menu-title">
          <img :src="$anm22.icons.getWorldIcon('pickUpRestaurant')" style="opacity:0.5;margin-right:5px;">
          <div class="com-anm22-app-text-l">
            {{ $anm22.strLang(lang, 'Menu', 'Menù') }}
          </div>
        </div>
        <li
          v-for="cat in mainCategories"
          :key="'main-cat-' + cat.id"
          class="display-flex categories-menu-item"
          @click="changePage(cat)"
        >
          <div
            :class="'com-anm22-app-text-m' + (selected.id === cat.id ? ' selected' : '')"
            :style="[selected.id === cat.id ? {fontWeight: 'bold'} : {}]"
          >{{ cat.langName.toUpperCase() }}</div>
        </li>
        <div class="vertical-height-div" style="height:20px;"></div>
      </ul>
    </nav>
    <div class="wg-xs-12 wg-md-10 products">
      <div 
          v-if="multiView"
          class="wg-row" 
          :style="{
            flexWrap: 'nowrap',
            alignItems: 'center',
            justifyContent: 'flex-end',
            marginTop: '10px',
          }">
        <img 
            :src="$anm22.icons.getWorldIcon('list')" 
            class="com-anm22-app-img-fixed-height-l" 
            :style="{cursor: 'pointer', opacity: view === 'image' ? '0.3' : '1'}"
            @click="view = 'list'">
        <div style="border-right:1px solid #ccc;height:30px;margin:0 10px;"></div>
        <img 
            :src="$anm22.icons.getWorldIcon('grid')" 
            class="com-anm22-app-img-fixed-height-l" 
            :style="{cursor: 'pointer', opacity: view === 'list' ? '0.3' : '1', marginRight: '10px'}"
            @click="view = 'image'">
      </div>
      <div class="vertical-height-div" style="height:10px;"></div>
      <div 
          v-for="cat in mainCategories"
          :key="'prod-cat-'+cat.id"
          class="wg-row com-anm22-food-menu-cat no-select"
          style="position:relative;"
          :ref="'cat-div-'+cat.id"
      >
        <div :ref="'cat-scroll-'+cat.id" style="position:absolute;top:-80px;"></div>
        <div class="cat-label">
          {{ cat.langName.toUpperCase() }}
        </div>
        <div v-if="getCategoryProducts(cat, false).length === 0 && getCategoryChildren(cat).length === 0" class="cat-empty-label">
          {{ $anm22.strLang(lang, 'No products in this category', 'Nessun prodotto in questa categoria') }}
        </div>
        <div class="wg-row" :style="{ alignItems: view === 'image' ? 'flex-start' : 'stretch' }">
        <product
          v-for="(prod,index) in getCategoryProducts(cat, true)"
          :key="'cat-prod-'+index"
          :view="view"
          :product="prod"
          :onclick="addOrderElement"
          :elements="elements"
        ></product>
        <div 
          v-for="(subcat) in getCategoryChildren(cat)"
          :key="'prod-cat-'+subcat.id"
          class="wg-row com-anm22-food-menu-cat-div-v no-select"
        >
          <div class="cat-label sub">
            {{ subcat.langName.toUpperCase() }}
          </div>
          <div class="com-anm22-food-fc-cat-empty-label" v-if="getCategoryProducts(subcat, false).length === 0">
            {{ $anm22.strLang(lang, 'No products in this sub-category', 'Nessun prodotto in questa sottocategoria') }}
          </div>
          <div class="wg-row" :style="{ alignItems: view === 'image' ? 'flex-start' : 'stretch' }">
            <product
              v-for="(prod) in getCategoryProducts(subcat, true)"
              :key="'cat-prod-'+prod.id"
              :view="view"
              :product="prod"
              :onclick="addOrderElement"
              :elements="elements"
            ></product>
          </div>
        </div>
        <div class="vertical-height-div" style="height:20px;"></div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Product from './Product.vue';
import WorldSubMenu from '../../../../../world/spa/components/WorldSubMenu.vue';

export default {
  props: {
    elements: Array,
    topOffset: {
      type: Number,
      default: 70
    }
  },
  components: {
    Product,
    WorldSubMenu
  },
  data() {
    return {
      view: 'list',
      selected: 0,
      menuOpen: false,
    };
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      licenseSelected: state => state.licenseSelected,
      windowHeight: state => state.windowHeight,
      windowWidth: state => state.windowWidth,
    }),
    license() {
      return this.$store.getters['foodLicenses/getByHash'](this.licenseSelected);
    },
    menuHeight() {
      return this.windowHeight - (this.windowWidth >= 992 ? 130 : 175);
    },
    menuStyle() {
      if(this.windowWidth >= 992) {
        return {
          top: (this.topOffset - 2) + 'px', 
          height: this.menuHeight + 'px', 
          overflowX: 'hidden'
        };
      } else {
        return {
          top: (this.topOffset - 2) + 'px'
        };
      }
    },
    multiView () {
      return this.license.placeOrderMultiview;
    },
    categories() {
      return this.$store.getters['foodCategories/getByLicense'](this.license.id)
        .filter(c => !c.deleted && c.visibleByCustomer);
    },
    mainCategories() {
      return this.categories
          .filter(c => !c.parent)
          .sort((a,b) => a.ordering - b.ordering);
    },
    products() {
      return this.$store.getters['foodProducts/getByLicense'](this.license.id)
        .filter(p => !p.deleted && p.status !== 2);
    },
  },
  methods: {
    changePage(cat) {
      this.selected = cat;
      this.$refs['cat-scroll-'+cat.id][0].scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    },
    setView(view) {
      this.$anm22.setCookie('fd_po_view', view, 31536000);
      this.view = view;
    },
    getCategoryProducts(cat, sort) {
      let products = this.products
          .filter(p => p.category === cat.id && p.status != 2);
      if(sort && this.license.orderByName) {
        const field = 'name' + this.$anm22.capitalizeFirst(this.lang);
        products.sort((a, b) => {
          const aValue = a[field] || a['name'];
          const bValue = b[field] || b['name'];
          return aValue.localeCompare(bValue);
        });
      }
      return products;
    },
    getCategoryChildren(cat) {
      return this.categories
          .filter(c => c.parent === cat.id)
          .sort((a,b) => a.ordering - b.ordering);
    },
    addOrderElement(product) {
      this.$emit('add-element', product);
    },
    handleScrolling(event) {
      const container = document.getElementById('main-scrolling-div');
      const contTop = container.scrollTop + 100;

      this.mainCategories.forEach(c => {
        const el = this.$refs['cat-div-'+c.id][0];

        if (el.offsetTop <= contTop && el.offsetTop + el.offsetHeight > contTop) {
          this.selected = c;
        }
      });
    }
  },
  created() {
    if(this.$anm22.getCookie("fd_po_view") !== ""){
      this.view = this.$anm22.getCookie("fd_po_view");
    } else if(this.multiView) {
      this.view = 'list';
    }
    if(this.categories.length) {
      this.selected = this.mainCategories[0];
    }
  },
  mounted() {
    document.getElementById('main-scrolling-div').addEventListener('scroll', this.handleScrolling);
    // Destroy is handled in PlaceOrder.vue
  }
};
</script>

<style lang="scss" scoped>
.com-anm22-food-fc-cat-button {
  text-align: center;
}
nav.categories {
  padding: 0 5px;
  border-right: 1px solid #ccc;
  background-color: #fff;
  ul {
    position: sticky;
    width: 100%;
    flex-direction: column;
    align-items: center;
    flex-wrap: nowrap;
    margin: 0;
    padding: 5px 0;
    text-align: center;
  }
  li {
    width: 100%;
    box-sizing: border-box;
    padding: 2px 0 2px 0;
    min-height: 35px;
    justify-content: center;
    align-items: center;
    flex-wrap: nowrap;
    cursor: pointer;
    border-radius: 4px;
    margin: 2px;
    &.selected {
      background-color: rgba(0, 0, 0, 0.05);
    }
    &:hover {
      border-radius: 5px;
      background-color: rgba(0, 0, 0, 0.05);
    }
    &.inactive {
      opacity: 0.3;
      pointer-events: none;
    }
  }
}
.products {
  padding: 0 5px;
}
.menu-title {
  padding: 2px 0 2px 0;
  min-height: 35px;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
}
.cat-label {
  display: block;
  color: #888;
  width: 100%;
  padding: 5px;
  font-size: 20px;
  &.sub {
    font-size: 18px;
  }
}
@media screen and (max-width: 991px) {
  nav.categories {
    position: sticky;
    z-index: 100;
    flex-direction: row;
    border: none;
    border-bottom: 1px solid #ccc;
    ul {
      position: static;
      flex-wrap: nowrap;
      overflow-y: hidden;
      flex-direction: row;
      li {
        width: auto;
        margin: 0;
        padding: 4px;
        white-space: nowrap;
      }
    }
  }
  .menu-title {
    padding: 4px 8px 4px 4px;
    border-right: 1px solid #ccc;
    margin-right: 4px;
  }
}
</style>
